import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

export const calculateDnaPositions = (
  starsData: StarData[],
  _config: GalaxyConfig
): StarPosition[] => {
  const amplitude = 30;
  const depth = 10;
  const height = 130;
  const turns = 6;
  const strandThickness = 1.2;
  const rungFraction = 0.28;
  const rungLevels = turns * 5;

  // Split into profit and loss, sort within each group
  const profitTraders: { idx: number; pnl: number }[] = [];
  const lossTraders: { idx: number; pnl: number }[] = [];
  starsData.forEach((star, i) => {
    if (star.pnl >= 0) profitTraders.push({ idx: i, pnl: star.pnl });
    else lossTraders.push({ idx: i, pnl: star.pnl });
  });
  profitTraders.sort((a, b) => b.pnl - a.pnl);
  lossTraders.sort((a, b) => a.pnl - b.pnl);

  const positions: StarPosition[] = new Array(starsData.length);

  function placeOnStrand(arr: { idx: number }[], phaseOffset: number) {
    const rungCount = Math.floor(arr.length * rungFraction);
    const strandCount = arr.length - rungCount;

    // STRAND
    for (let j = 0; j < strandCount; j++) {
      const idx = arr[j].idx;
      const t = j / Math.max(strandCount - 1, 1);
      const y = height / 2 - t * height;
      const angle = t * turns * Math.PI * 2 + phaseOffset;
      const baseX = amplitude * Math.sin(angle);
      const baseZ = depth * Math.cos(angle);
      const dx = (Math.random() - 0.5) * strandThickness;
      const dz = (Math.random() - 0.5) * strandThickness * 0.4;
      const dy = (Math.random() - 0.5) * strandThickness * 0.5;

      positions[idx] = { x: baseX + dx, y: y + dy, z: baseZ + dz };
    }

    // RUNGS
    for (let j = 0; j < rungCount; j++) {
      const idx = arr[strandCount + j].idx;
      const level = j % rungLevels;
      const t = (level + 0.5) / rungLevels;
      const y = height / 2 - t * height;
      const angle = t * turns * Math.PI * 2;
      const x1 = amplitude * Math.sin(angle + phaseOffset);
      const z1 = depth * Math.cos(angle + phaseOffset);
      const x2 = amplitude * Math.sin(angle + phaseOffset + Math.PI);
      const z2 = depth * Math.cos(angle + phaseOffset + Math.PI);
      const rungT = Math.random();

      positions[idx] = {
        x: x1 + (x2 - x1) * rungT + (Math.random() - 0.5) * 0.5,
        y: y + (Math.random() - 0.5) * strandThickness * 0.4,
        z: z1 + (z2 - z1) * rungT + (Math.random() - 0.5) * 0.3,
      };
    }
  }

  placeOnStrand(profitTraders, 0);
  placeOnStrand(lossTraders, Math.PI);

  return positions;
};
